import api from "./api";
import API_ROUTES from "./apiRoutes";
import { toast } from "react-toastify";

export const mergeUnits = async (payload) => {
  try {
    const res = await api.post(API_ROUTES.units.merge, payload);
    toast.success("Units merged");
    return res.data;
  } catch (error) {
    const message =
      error.response?.data?.error ||
      error.message ||
      "Failed to merge units";
    toast.error(message);
    throw error;
  }
};

export const unmergeUnits = async (payload) => {
  try {
    const res = await api.post(API_ROUTES.units.unmerge, payload);
    toast.success("Units unmerged");
    return res.data;
  } catch (error) {
    const message =
      error.response?.data?.error ||
      error.message ||
      "Failed to unmerge units";
    toast.error(message);
    throw error;
  }
};

